import { formatCodeableConcept } from '@medplum/core'
import { Container, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { Body } from 'src/components/MUIBased/Blocks/Body'
import { ContainerTitle } from 'src/components/MUIBased/Blocks/ContainerTitle'
import LoadingScreen from 'src/components/MUIBased/LoadingScreen'
import NavBarHeading from 'src/components/MUIBased/NavBarHeading'
import { StandardPageHeader } from 'src/components/MUIBased/pageHeaders'
import { useGetLabTestResultHistory } from 'src/pages/MUIBased/LabResults/History/hooks/useGetLabTestResultHistory'
import { LabResultsHistoryLineChart } from 'src/pages/MUIBased/LabResults/History/components/LabResultsHistoryLineChart'
import { ContactCareTeam } from 'src/pages/MUIBased/LabResults/LabResultDetail/components/ContactCareTeam'
import { LabResultHistoryTable } from './components/LabResultHistoryTable'

const LabTestHistory = () => {
    const { testCode } = useParams<{ testCode: string }>()
    const { isLoading, testResultHistory } = useGetLabTestResultHistory(
        testCode ?? ''
    )

    // Check if results are numerical (have valueQuantity with a value)
    const hasNumericalResults = testResultHistory.some(
        result =>
            result.valueQuantity?.value !== undefined &&
            result.valueQuantity?.value !== null
    )

    if (isLoading) {
        return <LoadingScreen isLoading />
    }

    if (testResultHistory.length === 0) {
        return (
            <Body>
                <StandardPageHeader />
                <NavBarHeading>Lab Test Result History</NavBarHeading>
                <Container>
                    <ContainerTitle
                        title="Lab Test History Not Found"
                        description="The requested test could not find any result."
                    />
                </Container>
            </Body>
        )
    }

    const testName = formatCodeableConcept(testResultHistory[0].code)
    const unit = testResultHistory[0].valueQuantity?.unit

    return (
        <Body>
            <StandardPageHeader />
            <NavBarHeading>Lab Test Result History</NavBarHeading>

            <Container>
                {/*Test Name 
                TODO: Consolidate heading styles with a component or variant*/}
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 700,
                        fontSize: '1.5rem',
                        lineHeight: '32px'
                    }}
                >
                    {testName}
                </Typography>

                {/*Normal Range */}
                <Typography variant="body2" color="text.secondary">
                    Normal range:{' '}
                    {testResultHistory[0].referenceRange?.[0].text || 'N/A'}
                    {unit ? ` ${unit}` : ''}
                </Typography>

                {/* Lab Results History Line Chart - only show for numerical results */}
                {hasNumericalResults && (
                    <LabResultsHistoryLineChart
                        testResultHistory={testResultHistory}
                    />
                )}

                {/* Lab Result History Table */}
                <LabResultHistoryTable testResultHistory={testResultHistory} />

                <ContactCareTeam />
            </Container>
        </Body>
    )
}

export default LabTestHistory
